import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ["handle"]
  static values = {
    updateUrl: String
  }

  connect() {
    if (!this.element.classList.contains('sortable-initialized')) {
      this.initializeSortable()
      this.element.classList.add('sortable-initialized')
    }
  }

  initializeSortable() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: '[data-draggable-target="handle"]',
      onEnd: this.onEnd.bind(this),
      ghostClass: 'opacity-50'
    })
  }

  onEnd(event) {
    const items = Array.from(this.element.children)
    const draggedId = event.item.dataset.draggableIdValue
    const oldPosition = event.oldIndex
    const newPosition = event.newIndex

    if (this.hasUpdateUrlValue && draggedId) {
      this.updatePositions(draggedId, oldPosition, newPosition)
    }
  }

  async updatePositions(draggedId, oldPosition, newPosition) {
    try {
      const response = await fetch(this.updateUrlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          dragged_id: draggedId,
          old_position: oldPosition,
          new_position: newPosition
        })
      })

      if (!response.ok) throw new Error('Error al actualizar posiciones')
    } catch (error) {
      console.error('Error:', error)
    }
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }
}